import React, { useState } from "react"
import PropTypes from "prop-types"
import { useParams, useOutletContext } from "react-router-dom"

import { Modal } from "@components/Page"
import { InvestmentShape } from "@components/Investment/shapes"
import { MODAL_LARGE_WIDTH, MODAL_LARGE_HEIGHT } from "@components"

import DistributionsScheduleForm from "./DistributionsScheduleForm"

const LABEL_TITLE = "Distributions Schedule"


const DistributionsScheduleModal = ({
  modal,
  investments,
}) => {
  const [ isOpen, setIsOpen ] = useState(false)

  const onClose = () =>
    setIsOpen(false)

  modal.current.open = () =>
    setIsOpen(true)

  modal.current.close = () =>
    onClose()

  // const collectionRef = useRef({})
  // const [ form ] = Form.useForm()

  const { id: projectId } = useParams()
  const { project } = useOutletContext()
  const { name } = project
  // const { request, showSuccessMessage } = useAppContext()

  const modalProps = {
    title: LABEL_TITLE,
    width: MODAL_LARGE_WIDTH,
    destroyOnClose: true,
    isOpen,
    onClose,
  }

  return (
    <Modal key={projectId} {...modalProps}>
      <div style={{ minHeight: MODAL_LARGE_HEIGHT }}>
        <DistributionsScheduleForm projectId={projectId} projectName={name} investments={investments} />
      </div>
    </Modal>
  )
}

DistributionsScheduleModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  investments: PropTypes.arrayOf(InvestmentShape).isRequired,
}

export default DistributionsScheduleModal
